var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrain = function SvgTrain(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.573 14.773H6.337c-.99 0-1.792-.829-1.792-1.85V3.668c0-1.022.803-1.85 1.792-1.85h8.236c.989 0 1.79.828 1.79 1.85v9.255c0 1.021-.801 1.85-1.79 1.85zm-.99-1.44c.768 0 1.39-.644 1.39-1.44 0-.794-.622-1.438-1.39-1.438-.768 0-1.39.644-1.39 1.439s.622 1.44 1.39 1.44zm-6.257 0c.768 0 1.39-.644 1.39-1.44 0-.794-.622-1.438-1.39-1.438-.767 0-1.39.644-1.39 1.439s.623 1.44 1.39 1.44zm4.335-10.075H9.248c-.294 0-.531.156-.531.349 0 .192.237.37.53.37h2.414c.294 0 .532-.178.532-.37 0-.193-.238-.35-.532-.35zM14.973 5.7c0-.554-.448-1.003-1-1.003H6.936c-.552 0-1 .45-1 1.003v3.032c0 .554.448 1.003 1 1.003h7.037c.552 0 1-.45 1-1.003V5.7zm-6.077 9.073l-.447 1.593h4.779l-.617-1.593h1.51l2.243 4.318h-1.58l-1.25-1.961H7.816l-.97 1.96H5.241l2.304-4.317h1.35z",
    fill: "#999"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrain, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/train.5043d6d3.svg";
export { ForwardRef as ReactComponent };